import { render, staticRenderFns } from "./ReceiptSummaryDetail.vue?vue&type=template&id=19f86434&scoped=true&"
import script from "./ReceiptSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiptSummaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSummaryDetail.vue?vue&type=style&index=0&id=19f86434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f86434",
  null
  
)

export default component.exports